import React, { useContext } from 'react'
import { DialogContent, Dialog } from '@mui/material'
import styled from 'styled-components'
import theme from 'styles/theme'
import { ActivityLogContext, closeProgramDoneModalAction } from 'activity/ducks/index'
import { NavLink } from 'react-router-dom'

export default function ProgramDoneRedirectDialog({ open, programCalendar }) {
  const { dispatch } = useContext(ActivityLogContext)

  return (
    <Dialog.Stylesheet
      open={open}
      disableEnforceFocus
    >
      <ProgramDoneRedirectDialog.Content>
        <div className="header">
          <h2>Great Job!</h2>
          <p>
            You have successfully completed Week {programCalendar.dateSelected.weekCount}
            {', '}
            Day {programCalendar.dateSelected.dayCount} of training
          </p>
          <p>
          Head to your Report page to see how your day looks or
          head to the Logs Page to make any edits
          </p>
        </div>
        <NavLink exact to="/myReport" className="item">
          <button
            type="button"
            className='reportBtn'
          >
            Report
          </button>
        </NavLink>
        <NavLink exact to="/activityLogs" className="item">
          <button
            type="button"
            className='logsBtn'
          >
            Logs
          </button>
        </NavLink>
      </ProgramDoneRedirectDialog.Content>
    </Dialog.Stylesheet>
  )
}

Dialog.Stylesheet = styled(Dialog)``

ProgramDoneRedirectDialog.Content = styled(DialogContent)`
  padding: 3rem !important;
  max-width: 40rem;
  margin: 0 auto;
  .header {
    h2 {
      font-weight: 500;
      font-size: 2rem;
    }
  }
  .content {
    margin-top: 2rem;
    h3 {
      color: ${theme.palette.secondary.g800};
      font-size: 1.25rem;
      font-weight: 500;
    }
  }

  .reportBtn {
    margin-top: 3rem;
    border: 0;
    width: 100%;
    padding: 1rem;
    background-color: ${theme.palette.secondary.g800};
    color: #fff;
    border-radius: 0.625rem;
    font-weight: 700;
  }

  .logsBtn {
    margin-top: 3rem;
    border-width: 1px;
    border-color: ${theme.palette.secondary.g800};
    width: 100%;
    padding: 1rem;
    background-color: white;
    color: ${theme.palette.secondary.g800};
    border-radius: 0.625rem;
    font-weight: 700;
  }
`

ProgramDoneRedirectDialog.Stylesheet = styled.div`
  .MuiToolbar-root {
    justify-content: flex-start;
  }
`
